import { circles } from "@/mocks/gossipData";
import Reveal from "./Reveal";

export default function Circles() {
  return (
    <section id="circles" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
                按圈子吃瓜更快
              </p>
              <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
                吃瓜分区 · 各圈有各圈的料
              </h2>
            </div>
            <a
              href="#circles"
              className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 hover:text-primary-600"
            >
              全部分区
              <i className="ri-arrow-right-up-line text-sm" />
            </a>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {circles.map((c, i) => (
            <Reveal key={c.name} delay={i * 50}>
              <a
                href="#circles"
                className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:bg-background-50 md:p-5"
              >
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${
                    i % 3 === 0
                      ? "bg-primary-100 text-primary-700"
                      : i % 3 === 1
                        ? "bg-accent-100 text-accent-700"
                        : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  <i className={`${c.icon} text-xl`} />
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="flex items-center gap-1.5 text-[15px] font-bold text-foreground-950">
                    {c.name}
                    <i className="ri-arrow-right-up-line text-sm text-foreground-400 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </h3>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">{c.desc}</p>
                </div>
                <span className="shrink-0 whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-[11px] font-medium text-accent-700">
                  {c.count}
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}